var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-pulse bg-white rounded-lg flex flex-col justify-between items-start shadow-md gap-4 flex-1 border-color-blue p-3 custom-min-height"},[_c('span',{staticClass:"h-6 bg-grey-light rounded w-3/4"}),_c('span',{staticClass:"h-6 bg-grey-light rounded w-1/2"}),_c('span',{staticClass:"h-4 bg-grey-light rounded w-1/4"})])
}]

export { render, staticRenderFns }